import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

/**
 * ProtectedRoute Component
 * Protects routes that require authentication
 * Uses Redux auth state (cookie-based) for consistency with Login flow
 */
const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const { isAuthenticated, user, loading } = useSelector((state) => state.auth);

  if (loading) {
    return (
      <div className="min-h-[200px] flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-2 border-DELVANTE-separator border-t-DELVANTE-accent" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (user && user.email_verified === false) {
    return <Navigate to="/verify-email" replace state={{ email: user.email, from: location }} />;
  }

  return children;
};

export default ProtectedRoute;
